import { memo, useContext } from 'react';
import Countdown, { CountdownRendererFn } from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { ConfigurationContext } from '../../providers/ConfigurationProvider';
import { LOGOUT_TIMEOUT } from './Common.constants';
import { formatCountdownNumber } from './Common.utils';
import Modal from './Modal';

interface InactiveCountdownModalProps {
  isInactiveModalVisible: boolean;
  handleKeepLogin: () => void;
  handleLogout: () => void;
}

function InactiveCountdownModal({
  isInactiveModalVisible,
  handleKeepLogin,
  handleLogout,
}: InactiveCountdownModalProps) {
  const config = useContext(ConfigurationContext);
  const [translate] = useTranslation();
  const logoutTimeout =
    config?.INACTIVITY_CONFIG.logout_timeout || LOGOUT_TIMEOUT;

  const renderCountdown: CountdownRendererFn = ({
    hours,
    minutes,
    seconds,
  }): React.ReactNode => {
    return (
      <span>
        {hours ? formatCountdownNumber(hours) : ''}
        {formatCountdownNumber(minutes)}:{formatCountdownNumber(seconds)}
      </span>
    );
  };

  const handleClickLogout: React.MouseEventHandler<HTMLDivElement> = (
    e
  ): void => {
    e.stopPropagation();
    handleLogout && handleLogout();
  };

  return (
    <Modal
      withoutContent
      isVisible={isInactiveModalVisible}
      customContainerStyle={'w-unset w-auto'}
      shouldHaveMaxZIndex
    >
      <div className="px-37px flex flex-col items-center justify-center">
        <div className="text-18px text-grey-title mt-46px">
          {translate('INACTIVE_MODAL_TITLE')}
        </div>
        <div className="mt-32px text-grey-title text-center">
          {translate('INACTIVE_MODAL_DESC')}{' '}
          <Countdown
            date={Date.now() + logoutTimeout}
            onComplete={handleLogout}
            renderer={renderCountdown}
          />{' '}
          {translate('MINUTES')}.
        </div>
        <div className="mt-50px flex flex-row items-center justify-center mb-67px">
          <div
            className="text-12px text-main-ui-blue mr-20px cursor-pointer"
            onClick={handleClickLogout}
          >
            {translate('LOGOUT')}
          </div>
          <div
            className="px-26px py-13px bg-main-ui-blue rounded-2px text-center cursor-pointer"
            onClick={handleKeepLogin}
          >
            <div className="text-14px text-white font-bold text-center">
              {translate('KEEP_LOGIN')}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default memo(InactiveCountdownModal);
